import { render, staticRenderFns } from "./history.vue?vue&type=template&id=3d1aca7d&scoped=true"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"
import style0 from "./history.vue?vue&type=style&index=0&id=3d1aca7d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1aca7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d1aca7d')) {
      api.createRecord('3d1aca7d', component.options)
    } else {
      api.reload('3d1aca7d', component.options)
    }
    module.hot.accept("./history.vue?vue&type=template&id=3d1aca7d&scoped=true", function () {
      api.rerender('3d1aca7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/reminder/components/history.vue"
export default component.exports